import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {Subscriptions} from '../models/subscriptions';
import {environment} from '../../environments/environment';
import {Status} from '../models/status';
import {Roles} from '../models/roles';
import {Contract} from '../models/contract';

@Injectable()
export class ContractService {

  CONTRACTS_API_URL: string = environment.serverUrl + 'api/1/contracts';

  constructor(private httpClient: HttpClient) {
  }

  getSubscriptions(email: String): Observable<Subscriptions[]> {
    return this.httpClient.get<Subscriptions[]>(encodeURI(this.CONTRACTS_API_URL + '/subscriptions/' + email));
  }

  unsubscribeFromContract(contractId: number): Observable<void> {
    const contract = {status: Status[Status.ARCHIVED]};
    return this.httpClient.patch<void>(`${this.CONTRACTS_API_URL}/${contractId}`, contract);
  }

  createContract(groupId: number, email: string, role: Roles, subscriptionPlanId: number): Observable<Contract> {
    const contract = {
      groupId: groupId,
      userEmail: email,
      type: Roles[role],
      subscriptionPlanId: subscriptionPlanId
    };
    return this.httpClient.post<Contract>(this.CONTRACTS_API_URL, contract);
  }

  getApplicableTypeForGroup(groupId: number): Observable<Roles[]> {
    return this.httpClient.get<Roles[]>(`${this.CONTRACTS_API_URL}/subscriptiontypes/${groupId}`);
  }

  sendEmail(contractId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.CONTRACTS_API_URL}/email/${contractId}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contract.service.ts